import { type ReactNode } from 'react'

import { LegalPage } from './LegalPage'
import { TERMS_OF_SERVICE } from '../content/legal'

/** `/terms` — M17-T17. Text approved by AMTC; see `docs/legal/`. */
export function Terms(): ReactNode {
  return <LegalPage doc={TERMS_OF_SERVICE} />
}
